<template>
	<div class="borrwingClass">
		<div v-if="!inforFlag">
			<!-- <span class="borrwingClass">样品申请再提交</span> -->
			<span class="sampleTypeClass">样品申请再提交</span>
			<div class="searchDivClass">
				<div class="titleNameClass">
					<span class="lineClass"></span>
					<span class="sampleTypeClass">样品类型</span>
				</div>
				<div class="inforNameClass">
					<div class="spanDivClass" v-for="(item, index) in inforArr" :key="index">
						<span class="nameClass" v-if="item && item[0]">{{ item[0].level }}</span>
						<span
							:class="activeItem.includes(itemChild.name) ? 'typeClass1' : 'typeClass2'"
							v-for="(itemChild, indexC) in item"
							:key="indexC"
							@click="changeSampleType(itemChild, indexC)"
							>{{ itemChild.name }}</span
						>
					</div>
				</div>
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品编号</span>
						</div>

						<el-input v-model="sampleObj.code" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品原始重量</span>
						</div>
						<el-input v-model="sampleObj.currentWeight" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品特征</span>
						</div>
						<el-input v-model="sampleObj.sampleType" clearable></el-input>
					</div>
					<div class="sampleNum" style="visibility: hidden">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用状态</span>
						</div>
						<el-select v-model="sampleObj.statusList" clearable placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</div>
				</div>
				<el-button class="btnClass" @click="searchSampleFunc()"> <i class="el-icon-check"></i>确定</el-button>
			</div>
			<div class="tableDataClass">
				<div style="text-align: left">查询结果：共{{ totalMoonSample }}条</div>
				<el-table :data="moonSampleTableData" stripe :height="500" style="width: 100%">
					<el-table-column type="index" width="50" align="center"></el-table-column>
					<el-table-column prop="orderNo" label="样品编号"> </el-table-column>

					<el-table-column prop="borrowWeight" label="借用质量(mg)" width="120"> </el-table-column>
					<el-table-column prop="expectedConsumption" label="预期消耗量(mg)" width="130"> </el-table-column>
					<el-table-column prop="returnWeight" label="返回质量(mg)" width="120"> </el-table-column>
					<el-table-column label="状态" align="center" prop="status">
						<template slot-scope="scope">
							<!-- 状态;0:待审核,1:审核通过,2:审核驳回,3:返还中,4:返还通过,5:返还失败,6:已终结 -->
							<!-- 0:分发审核中,1:待分发,2:审核驳回,3:返还检测中,4:检测通过,5:检测不通过,6:已终结,7:借用中 -->

							<span v-if="scope.row.status == 0">分发审核中</span>
							<span v-else-if="scope.row.status == 1">待分发</span>
							<span v-else-if="scope.row.status == 2">审核驳回</span>
							<span v-else-if="scope.row.status == 3">返还检测中</span>
							<span v-else-if="scope.row.status == 4">检测通过</span>
							<span v-else-if="scope.row.status == 5">检测不通过</span>
							<span v-else-if="scope.row.status == 7">借用中</span>
							<span v-else>已终结</span>
						</template>
					</el-table-column>
					<el-table-column label="使用方式">
						<template slot-scope="scope">
							<span v-if="scope.row.useType == 1">原样使用</span>
							<span v-else-if="scope.row.useType == 2">消耗使用</span>
							<span v-else-if="scope.row.useType == 3">破坏性使用</span>
							<span v-else-if="scope.row.useType == 4">展览教育科普</span>
							<span v-else-if="scope.row.useType == 5">赠送</span>
							<!-- <span v-else-if="scope.row.useType == 6">科普</span> -->
							<span v-else>其他</span>
						</template>
					</el-table-column>
					<el-table-column label="借用审核驳回原因" width="150">
						<template slot-scope="scope">
							<span>{{ scope.row.borrowReviewReason == null ? '/' : scope.row.borrowReviewReason }}</span>
						</template>
					</el-table-column>
					<el-table-column label="返还审核驳回原因" width="150">
						<template slot-scope="scope">
							<span>{{ scope.row.returnReviewReason == null ? '/' : scope.row.returnReviewReason }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<!-- <el-button @click="handleInforClick(scope.row)" type="text" size="small">详情</el-button> -->
							<el-button type="text" size="small" @click="submitAgenSample(scope.row)">重新提交</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block" style="background-color: #fff; height: 50px; display: flex; justify-content: end; align-items: center">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="pageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalMoonSample"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 添加或修改月球样品借用返还对话框 -->
		<el-dialog title="月球样品借用申请信息" :visible.sync="openDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="60%">
			<addSampleInfoVue ref="addFormInit"></addSampleInfoVue>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="returnFunc">取 消</el-button>
					<el-button type="primary" @click="submitForm">确 认</el-button>
				</div>
			</template>
		</el-dialog>

		<!-- 添加或修改订单返还信息对话框 -->
		<el-dialog title="返还申请表" :visible.sync="openReturnDialog" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
			<el-form ref="returnRef" :model="form" label-width="130px">
				<el-form-item label="样品编码" prop="orderNo">
					<el-input v-model="form.orderNo" :disabled="true" placeholder="请输入样品编码" />
				</el-form-item>
				<el-form-item label="借用质量(mg)" prop="borrowWeight">
					<el-input v-model="form.borrowWeight" :disabled="true" placeholder="请输入借用质量" />
				</el-form-item>
				<el-form-item label="预期消耗量(mg)" prop="expectedConsumption">
					<el-input v-model="form.expectedConsumption" :disabled="true" placeholder="请输入预期消耗量" />
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="返还时间" prop="expectedReturnTime">
							<el-date-picker clearable v-model="form.expectedReturnTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择预计返还时间"> </el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="检测项目" prop="checkType">
							<el-select v-model="form.checkType" clearable placeholder="请选择">
								<el-option label="称重" value="1"> </el-option>
								<el-option label="外观检查" value="2"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="实际消耗量(mg)" prop="actualConsumption">
							<el-input v-model="form.actualConsumption" placeholder="请输入实际消耗量" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="样品返还质量(mg)" prop="returnWeight">
							<el-input v-model="form.returnWeight" placeholder="请输入样品返还质量" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="returnFunc">取 消</el-button>
					<el-button type="primary" @click="submitFormReturnForm">确 认</el-button>
				</div>
			</template>
		</el-dialog>

		<sampleInfor v-if="inforFlag" ref="sampleInfoRef" @goBackFunc="goBackFunc"></sampleInfor>
	</div>
</template>

<script>
import cookie from '@/utils/cookie'
import sampleInfor from '../borrowingAndReturn/sampleSearch/moonSampleInfor.vue'
import addSampleInfoVue from './../borrowingAndReturn/sampleSearch/addSampleInfo.vue'
import mySampleBorrowingVue from './../borrowingAndReturn/mySampleBorrowing.vue'
export default {
	components: {
		sampleInfor,
		addSampleInfoVue,
		mySampleBorrowingVue
	},
	data() {
		return {
			form: {
				orderNo: null,
				sampleOrderId: null,
				sampleReturnApplication: null,
				sampleReturnCheck: null,
				checkType: null,
				sampleReturnCheckReport: null,
				sampleReturnAnalysisData: null,
				actualConsumption: null,
				returnWeight: null,
				useStartTime: null,
				borrowWeight: null,
				expectedConsumption: null,
				useEndTime: null
			},
			openReturnDialog: false,
			addBorrowForm: {},
			options: [
				{
					value: '1',
					label: '可申请'
				},
				{
					value: '2',
					label: '内部借用'
				},
				{
					value: '3',
					label: '外部借用'
				},
				{
					value: '4',
					label: '审核中'
				},
				{
					value: '5',
					label: '反还监测中'
				}
			],
			openDialog: false,
			active: 0,
			inforFlag: false,
			activeItem: [],
			inforArr: [[{ level: '一级', itemChild: [] }]],
			currentPage: 1,
			pageSize: 10,
			totalMoonSample: 0,
			moonSampleTableData: [],
			sampleObj: {
				code: '',
				sampleType: '',
				statusList: [],
				currentWeight: ''
			}
		}
	},
	mounted() {
		this.getMoonSampleListFunc()
		this.initFunc()
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val
			this.initFunc()
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.initFunc()
		},
		nextFunc() {
			this.$nextTick(() => {
				const addFormDataInit = this.$refs.addFormInit.submitFunc()
				console.log(addFormDataInit)
				if (!addFormDataInit) {
					this.active = 0
					return
				}
				this.$refs.addMySampleBorrow.borrowInit(this.addBorrowForm)
			})
		},
		returnFunc() {
			this.$nextTick(() => {
				if (this.addBorrowForm) {
					let formObj = this.addBorrowForm
					// formObj.id = this.addBorrowForm.sampleDataId
					formObj.code = this.addBorrowForm.orderNo
					this.addBorrowForm = this.$refs.addFormInit.initForm(formObj)
				}
			})
		},
		goBackFunc(type) {
			if (type == 1) {
				this.inforFlag = false
			} else {
				this.editInforFlag = false
			}
		},
		async submitFormReturnForm() {
			let newForm = {
				...this.form,
				action: 'UserReturn',
				status: 3
			}
			console.log(newForm)
			let res = await this.$http.put(this.$const.moonSample.updateOrder, newForm)
			if (res && res.code == 200) {
				this.openReturnDialog = false
				this.$message.success('申请成功！')
				this.initFunc()
			}
		},
		async submitForm() {
			this.addBorrowForm.createBy = this.$cookie.get('userCreateBy')
			// const borrwingForm = this.$refs.addMySampleBorrow.submitSampleFunc()
			let newForm = {
				...this.addBorrowForm,
				action: 'UserBorrow',
				status: 0,
				sampleOrderBorrow: {
					// ...borrwingForm
				}
			}
			console.log(newForm)
			let res = await this.$http.put(this.$const.moonSample.addMoonSampleBorrowingReturn, newForm)
			if (res && res.code == 200) {
				this.openDialog = false
				this.$message.success('申请成功！')
				this.initFunc()
			}
		},
		async handleInforClick(row) {
			this.inforFlag = true
			await this.$http.get(this.$const.moonSample.viewsInfo + `/${row.id}`)
			this.$nextTick(() => {
				this.$refs.sampleInfoRef.initDataFunc(row)
			})
		},
		submitAgenSample(row) {
			if (row.status == 2) {
				//流程同提交借用申请 只用修改基础信息部分不用重新上传文件
				this.addBorrowForm = row
				this.openDialog = true
				this.$nextTick(() => {
					let formObj = this.addBorrowForm
					// formObj.id = this.addBorrowForm.sampleDataId
					formObj.code = this.addBorrowForm.orderNo
					this.addBorrowForm = this.$refs.addFormInit.initForm(row)
				})
			} else if (row.status == 7) {
				//流程同提交返还申请 同样只用修改基础信息 表单内的基础信息回显根据订单信息读取
				this.openReturnDialog = true
				this.form = row
			}
		},
		async getMoonSampleListFunc() {
			this.inforArr[0] = []
			this.inforArr[1] = []
			this.inforArr[2] = []
			this.inforArr[3] = []
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleTypeList + `?pageNum=1&pageSize=100`)
			if (res && res.code == 200) {
				const resultData = res.data
				resultData.forEach((element) => {
					if (element.level == '一级') {
						this.inforArr[0].push(element)
					} else if (element.level == '二级') {
						this.inforArr[1].push(element)
					} else if (element.level == '三级') {
						this.inforArr[2].push(element)
					} else if (element.level == '四级') {
						this.inforArr[3].push(element)
					}
				})
			}
		},
		async initDataFunc() {
			let res = await this.$http.get(this.$const.moonSample.failedListSubmit + `?pageNum=1&pageSize=10`)
			if (res && res.code == 200) {
				console.log(res)
			}
		},
		async initFunc() {
			let sampleCategory1 = '',
				sampleCategory2 = '',
				sampleCategory3 = '',
				sampleCategory4 = ''

			if (this.activeItemObj && this.activeItemObj.length > 0) {
				this.activeItemObj.forEach((element) => {
					if (element.level == '一级') {
						sampleCategory1 += element.code + ','
					} else if (element.level == '二级') {
						sampleCategory2 += element.code + ','
					} else if (element.level == '三级') {
						sampleCategory3 += element.code + ','
					} else if (element.level == '四级') {
						sampleCategory4 += element.code + ','
					}
				})
				const reg = /,$/gi
				sampleCategory1 = sampleCategory1.replace(reg, '')
				sampleCategory2 = sampleCategory2.replace(reg, '')
				sampleCategory3 = sampleCategory3.replace(reg, '')
				sampleCategory4 = sampleCategory4.replace(reg, '')
			}
			const params = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				statusList: this.sampleObj.statusList.length > 0 ? this.sampleObj.statusList.toString() : `1`
			}
			if (sampleCategory1 !== '') params.sampleCategory1 = sampleCategory1
			if (sampleCategory2 !== '') params.sampleCategory2 = sampleCategory2
			if (sampleCategory3 !== '') params.sampleCategory3 = sampleCategory3
			if (sampleCategory4 !== '') params.sampleCategory4 = sampleCategory4
			if (this.sampleObj.code !== '') params.code = this.sampleObj.code
			if (this.sampleObj.sampleType !== '') params.sampleType = this.sampleObj.sampleType
			if (this.sampleObj.status !== '') params.status = this.sampleObj.status
			if (this.sampleObj.currentWeight !== '') params.currentWeight = this.sampleObj.currentWeight

			let res = await this.$http.get(this.$const.moonSample.failedListSubmit, params)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.borrwingClass {
	width: 1200px;

	.sampleTypeClass {
		height: 80px;
		font-style: normal;
		display: block;
		line-height: 80px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		text-align: left;
		font-style: normal;
	}
	.searchDivClass {
		// height: 246px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		margin-bottom: 22px;
		padding: 10px;
		text-align: center;
		.titleNameClass {
			display: flex;
			justify-content: left;
			align-items: center;
			height: 30px;
			padding: 5px;
			.lineClass {
				width: 2px;
				height: 16px;
				background: #15418c;
			}
			.sampleTypeClass {
				height: 21px;
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 16px;
				color: #000000;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				display: block;
				margin-left: 8px;
			}
		}

		.sampleEditClass {
			display: flex;
			justify-content: space-around;
			align-items: baseline;
			margin-top: 10px;
			.sampleNum {
				width: 280px;
				padding: 6px;
				.sampleNumTitleClass {
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					.lineClass {
						width: 2px;
						height: 16px;
						background: #15418c;
					}
					.sampleNumClass {
						height: 21px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #000000;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						display: block;
						margin-left: 8px;
					}
				}
			}
		}
		.inforNameClass {
			display: flex;
			justify-content: left;
			align-items: baseline;
			flex-wrap: wrap;
			.spanDivClass {
				display: flex;
				justify-content: stretch;
				-webkit-box-align: baseline;
				align-items: center;
				padding: 8px;
				// width: 50%;
				height: 60px;
			}
			.nameClass {
				width: 50px;
				margin-right: 10px;
				height: 40px;
				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #000000;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.typeClass2:hover,
			.typeClass1 {
				// width: 116px;
				min-width: 96px;
				padding-left: 10px;
				padding-right: 10px;
				max-width: max-content;
				margin-right: 5px;
				height: 40px;
				background: #15418c;
				border-radius: 4px;
				color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.typeClass2 {
				// width: 116px;
				height: 40px;
				min-width: 96px;
				padding-left: 10px;
				padding-right: 10px;
				max-width: max-content;
				margin-right: 5px;
				background: radial-gradient(396% 161% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
				border-radius: 4px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
		}
		.btnClass {
			background: #15418c;
			border-radius: 4px;

			font-family: MicrosoftYaHeiUI;
			font-size: 16px;
			color: #ffffff;
			line-height: 21px;
			text-align: left;
			font-style: normal;
			line-height: 10px;
			text-align: left;
			font-style: normal;
			margin-top: 5px;
		}
	}
}
</style>
<style>
.el-table th.el-table__cell.is-leaf {
	background-color: #15418c;
	color: #ffffff;
}
.el-table tr {
	background: #f0f5ff;
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	color: #333333;
	font-size: 14px;
}
.sampleNum .el-input__inner {
	/* width: 280px; */
	height: 36px;
	/* background: #fafafa; */
	border-radius: 4px;
	border: 1px solid #cccccc;
}
.moonSampleSearchClass .el-dialog__header {
	text-align: left;
	background-color: #fdfdfd;
}
</style>
